import React from 'react';

const Logo = ({ className = "h-12 w-auto" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 280 60" 
      className={className} 
      fill="none"
      role="img" 
      aria-label="Delight Store Logo"
    >
      {/* --- ICON: The Delight Bag --- */}
      
      {/* Bag Body (Orange) */}
      <rect x="10" y="15" width="40" height="40" rx="8" fill="#F97316" />
      
      {/* Bag Handle (Blue) */}
      <path 
        d="M20 15V10C20 4.477 24.477 0 30 0C35.523 0 40 4.477 40 10V15" 
        stroke="#1E3A8A" 
        strokeWidth="4" 
        strokeLinecap="round" 
      />
      
      {/* The "Delight" Smile (White) */}
      <path 
        d="M22 38C22 38 25 43 30 43C35 43 38 38 38 38" 
        stroke="white" 
        strokeWidth="3" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      
      {/* --- TEXT: Brand Name --- */}
      
      {/* "Delight" in Dark Blue (Trust) */}
      <text 
        x="65" 
        y="42" 
        fontFamily="ui-sans-serif, system-ui, sans-serif" 
        fontWeight="800" 
        fontSize="32" 
        fill="#1E3A8A"
      >
        Delight
      </text>
      
      {/* "Store" in Orange (Energy) */}
      <text 
        x="185" 
        y="42" 
        fontFamily="ui-sans-serif, system-ui, sans-serif" 
        fontWeight="600" 
        fontSize="32" 
        fill="#F97316"
      >
        Store
      </text>
    </svg>
  );
};

export default Logo;